import { IconClock, IconOperation } from 'assets/img';
import { NodeLibraryItem } from './node-library.types';
import { NodeType } from '../../hooks/use-sidebar-control/use-sidebar-control.types';

export const nodeLibraryItems: NodeLibraryItem[] = [
  {
    type: NodeType.Wait,
    name: 'Timed Delay',
    description:
      'Delay workflow execution until a specified percentage of time remains between shift creation and start time. For example, with 90% and a shift created at 10:20 starting at 10:30, execution continues at 10:21 when 90% of the time remains.',
    Icon: IconClock,
  },
  {
    type: NodeType.Action,
    name: 'Action',
    description: 'Define what should happen next in this workflow.',
    Icon: IconOperation,
  },
];
